<template>
  <!-- Popup de Conversas minimizado: ícone de chat no canto inferior esquerdo (ao lado do menu lateral). -->
  <div v-if="state === 'minimized'" class="icb" :style="{ left: `${left}px`, bottom: `${bottom}px` }">
    <button type="button" class="icb-btn" :title="title" :aria-label="title" @click="restoreInternalChatPopup">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
      <span v-if="unread" class="icb-badge">{{ unread > 99 ? '99+' : unread }}</span>
      <span v-if="exampleMode" class="icb-example">exemplo</span>
    </button>
    <button type="button" class="icb-close" title="Fechar Conversas" aria-label="Fechar Conversas" @click="state = 'closed'">×</button>
  </div>
</template>

<script setup lang="ts">
// Conversas minimizado (InternalChatPopup): clique volta o popup no mesmo lugar e tamanho; o × pequeno fecha.
// Fica acima do telefone do navegador (PhoneWidget), que ocupa o mesmo canto quando o Linkus está ligado.
import { computed } from 'vue'
import { restoreInternalChatPopup, useInternalChatPopup } from '@/composables/useInternalChatPopup'
import { useAgentChatCp } from '@/composables/useAgentChatCp'
import { useLinkus } from '@/composables/useLinkus'

const props = defineProps<{ sidebarOpen: boolean }>()

const { state, exampleMode } = useInternalChatPopup()
const { totalUnread } = useAgentChatCp()
const { availability } = useLinkus()

const left = computed(() => (props.sidebarOpen ? 220 : 64) + 16)
const bottom = computed(() => (availability.value?.available ? 16 + 64 : 16))
const unread = computed(() => (exampleMode.value ? 2 : totalUnread.value))
const title = computed(() => `Conversas${unread.value ? ` (${unread.value} não lidas)` : ''} — clique pra abrir`)
</script>

<style scoped>
.icb { position: fixed; z-index: 3890; transition: left .2s ease, bottom .2s ease; }
.icb-btn {
  position: relative; width: 52px; height: 52px; border-radius: 50%; border: none; cursor: pointer;
  background: #2563eb; color: #fff; box-shadow: 0 8px 22px rgba(37, 99, 235, .35); display: flex; align-items: center; justify-content: center;
}
.icb-btn:hover { background: #1d4ed8; }
.icb-btn:focus-visible { outline: 3px solid #93c5fd; outline-offset: 2px; }
.icb-btn svg { width: 22px; height: 22px; }
.icb-badge {
  position: absolute; top: -3px; right: -3px; min-width: 20px; height: 20px; padding: 0 5px; border-radius: 10px; box-sizing: border-box;
  background: #e11d48; color: #fff; font-size: 11px; font-weight: 700; display: flex; align-items: center; justify-content: center; border: 2px solid #fff;
}
.icb-example {
  position: absolute; bottom: -8px; left: 50%; transform: translateX(-50%); font-size: 9.5px; font-weight: 700; text-transform: uppercase;
  letter-spacing: .04em; background: #fffbeb; color: #92400e; border: 1px solid #fde68a; border-radius: 6px; padding: 0 4px; white-space: nowrap;
}
.icb-close {
  position: absolute; top: -6px; left: -6px; width: 20px; height: 20px; border-radius: 50%; border: none; cursor: pointer; padding: 0;
  background: var(--ink-80, #1f2937); color: #fff; font-size: 13px; line-height: 20px; opacity: 0; transition: opacity .15s;
}
.icb:hover .icb-close, .icb-close:focus-visible { opacity: 1; }
@media (prefers-reduced-motion: reduce) { .icb { transition: none; } }
</style>
